var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "12px",
    viewBox: "0 0 20 12",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group-14-Copy-3",
    transform: "matrix(-1 8.742278E-08 -8.742278E-08 -1 18.649414 10.649414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.60714 5.3125L12.5546 5.3125",
    id: "Line-2",
    fill: "none",
    fillRule: "evenodd",
    stroke: "#FFFFFF",
    strokeWidth: 1.2987013,
    strokeLinecap: "square"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7857 6.25C15.1408 6.25 15.4286 5.97018 15.4286 5.625C15.4286 5.27982 15.1408 5 14.7857 5C14.4307 5 14.1429 5.27982 14.1429 5.625C14.1429 5.97018 14.4307 6.25 14.7857 6.25Z",
    id: "Oval-3",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.3571 6.25C17.7122 6.25 18 5.97018 18 5.625C18 5.27982 17.7122 5 17.3571 5C17.0021 5 16.7143 5.27982 16.7143 5.625C16.7143 5.97018 17.0021 6.25 17.3571 6.25Z",
    id: "Oval-3-Copy",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.73427 0.329774L0.431393 4.63265Q0.351696 4.71235 0.308564 4.81648Q0.265432 4.92061 0.265432 5.03331L0.265434 5.0348L0.265433 5.03614Q0.265433 5.14885 0.308565 5.25298Q0.351696 5.35711 0.431394 5.4368L4.73427 9.73968Q4.81397 9.81938 4.9181 9.86251Q5.02223 9.90564 5.13493 9.90564Q5.24764 9.90564 5.35177 9.86251Q5.4559 9.81938 5.5356 9.73968L5.53701 9.73827Q5.57647 9.6988 5.60748 9.6524Q5.63848 9.606 5.65984 9.55444Q5.6812 9.50288 5.69209 9.44814Q5.70297 9.39341 5.70297 9.3376Q5.70297 9.28179 5.69209 9.22706Q5.6812 9.17232 5.65984 9.12076Q5.63848 9.0692 5.60748 9.0228Q5.57647 8.9764 5.53701 8.93694L1.63481 5.03473L5.53701 1.13252Q5.57648 1.09306 5.60748 1.04665Q5.63849 1.00025 5.65984 0.948692Q5.6812 0.897132 5.69209 0.842396Q5.70297 0.787661 5.70297 0.731853Q5.70297 0.676045 5.69209 0.62131Q5.6812 0.566574 5.65984 0.515015Q5.63848 0.463455 5.60748 0.417053Q5.57648 0.37065 5.53701 0.331188L5.5356 0.329774Q5.49614 0.290312 5.44973 0.259306Q5.40333 0.228301 5.35177 0.206944Q5.30021 0.185588 5.24548 0.1747Q5.19074 0.163813 5.13493 0.163813Q5.07913 0.163813 5.02439 0.1747Q4.96965 0.185588 4.9181 0.206944Q4.86654 0.228301 4.82013 0.259306Q4.77373 0.290312 4.73427 0.329774Z",
    id: "Combined-Shape",
    fill: "#FFFFFF",
    fillRule: "evenodd",
    stroke: "none"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow_right.067bd927004cd8e9f3b6f90746567ed3.svg";
export { ForwardRef as ReactComponent };